module.exports = __webpack_public_path__ + "img/home-red.eba55cf4.png";